import type { ReactNode } from 'react';
import { Pop } from '../../components/Pop';

// Un numero del giorno come tessera colorata con un pop che sbuca dall'angolo (tela «PopTown Pop
// Style», Dashboard). La tinta la dà la posizione nella riga (`.dash-kpis` in theme.css).
export function KpiTile({
  label,
  value,
  note,
  pop,
  dot,
  onClick,
}: {
  label: string;
  value: ReactNode;
  note?: ReactNode;
  pop: string;
  dot?: boolean;
  onClick?: () => void;
}) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag className="dash-kpi" type={onClick ? 'button' : undefined} onClick={onClick}>
      <span className="dash-kpi-label">
        {dot && <span className="dash-kpi-dot" aria-hidden />}
        {label}
      </span>
      <span className="dash-kpi-value">{value}</span>
      {note && <span className="dash-kpi-note">{note}</span>}
      <span className="dash-kpi-pop" aria-hidden>
        <Pop avatar={pop} size={86} />
      </span>
    </Tag>
  );
}
